module.exports = __webpack_public_path__ + "static/media/thumbs-up.58fdd5b9.svg";